// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"443":"about","631":"contact"}[chunkId] + "." + {"443":"85c5b564","631":"6be41753"}[chunkId] + ".js";
};